<!--<template >
  <form-control :label="label" :error="error">
    <template slot="content" slot-scope="scope">
      <input :type="type" :value="value" @input="updateValue" @change="updateValue" @blur="$emit('blur')" :disabled="disabled" class="el-input__inner" :class="{ 'input': true, 'input__error': !!error }">
    </template>  
  </form-control>
</template>-->
<template >
  <div class="form__input el-input el-input--mini">
    <label slot="title" v-if="label" class="form__label">{{ label }}</label>
    <input :type="type" :value="value" @input="updateValue" @change="updateValue" @blur="$emit('blur')" :disabled="disabled" class="el-input__inner" :class="{ 'input': true, 'input__error': !!error }">
    <transition name="slide">
      <p v-show="error" class="form__error"></p>
    </transition> 
  </div> 
</template>

<script>
import FormControlItem from "./FormControlItem.vue";
export default {
  components: { "form-control": FormControlItem },
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    }
  },
  props: {
    value: String,
    label: {
      type: String
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: "text",
      validator: val => {
        return (
          ["url", "text", "password", "email", "search"].indexOf(val) !== -1
        );
      }
    }
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
      this.$emit("change", e);
    }
  }
};
</script>
